import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "icon", "label", "className", "open"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useEffect, useId, useState } from 'react';
import { HiChevronDown } from 'react-icons/hi';
import { useTheme } from '../Flowbite/ThemeContext';
import { Tooltip } from '../Tooltip';
import { useSidebarContext } from './SidebarContext';
import { SidebarItemContext } from './SidebarItemContext';
var SidebarCollapse = function SidebarCollapse(_ref) {
  var children = _ref.children,
    Icon = _ref.icon,
    label = _ref.label,
    className = _ref.className,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    props = _objectWithoutProperties(_ref, _excluded);
  var id = useId();
  var _useSidebarContext = useSidebarContext(),
    isCollapsed = _useSidebarContext.isCollapsed;
  var _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var theme = useTheme().theme.sidebar.collapse;
  useEffect(function () {
    return setOpen(open);
  }, [open]);
  var Wrapper = function Wrapper(_ref2) {
    var children = _ref2.children;
    return _jsx("li", {
      children: isCollapsed && !isOpen ? _jsx(Tooltip, {
        content: label,
        placement: "right",
        children: children
      }) : children
    });
  };
  return _jsxs(Wrapper, {
    children: [_jsxs("button", _objectSpread(_objectSpread({
      className: classNames(theme.button, className),
      id: "flowbite-sidebar-collapse-".concat(id),
      onClick: function onClick() {
        return setOpen(!isOpen);
      },
      title: label,
      type: "button"
    }, props), {}, {
      children: [Icon && _jsx(Icon, {
        "aria-hidden": true,
        className: classNames(theme.icon.base, theme.icon.open[isOpen ? 'on' : 'off']),
        "data-testid": "flowbite-sidebar-collapse-icon"
      }), isCollapsed ? _jsx("span", {
        className: "sr-only",
        children: label
      }) : _jsxs(_Fragment, {
        children: [_jsx("span", {
          className: theme.label.base,
          "data-testid": "flowbite-sidebar-collapse-label",
          children: label
        }), _jsx(HiChevronDown, {
          "aria-hidden": true,
          className: theme.label.icon
        })]
      })]
    })), _jsx("ul", {
      "aria-labelledby": "flowbite-sidebar-collapse-".concat(id),
      className: theme.list,
      hidden: !isOpen,
      children: _jsx(SidebarItemContext.Provider, {
        value: {
          isInsideCollapse: true
        },
        children: children
      })
    })]
  });
};
SidebarCollapse.displayName = 'Sidebar.Collapse';
export default SidebarCollapse;